var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthFalling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff4d4f;opacity:0.15;}.b{fill:none;stroke:#ff4d4f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,4.5,4.5,1,13,9.5m0,0H9.5m3.5,0v-3",
    transform: "translate(5 6.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthFalling);
export default __webpack_public_path__ + "static/media/growth-falling.53f7731a519115c4f287e41c055785ce.svg";
export { ForwardRef as ReactComponent };